import { forwardRef } from 'react';
import { cva, VariantProps } from 'class-variance-authority';

import { cn } from '../../lib/styles/styles.lib';
import { Button, ButtonProps } from '../../designSystem/Button';

interface FloatingActionItemProps extends Omit<React.HTMLAttributes<HTMLButtonElement>, 'color'> {
  icon?: React.ReactNode;
}

const buttonVariants = cva('', {
  variants: {
    color: {
      default: 'border-none data-[disabled=true]:bg-transparent data-[disabled=true]:opacity-70',
      destructive: [
        'bg-bg-inter-primary-default text-red-4 fill-red-4 border-none',
        'hover:bg-red-10/40 hover:text-red-5 hover:fill-red-5',
        'disabled:opacity-50',
      ].join(' '),
    },
  },
  defaultVariants: {
    color: 'default',
  },
});

export const ActionBarItem = forwardRef<
  HTMLButtonElement,
  FloatingActionItemProps & VariantProps<typeof buttonVariants> & ButtonProps
>(({ icon, children, color, className, ...rest }, ref) => {
  return (
    <Button ref={ref} leftIcon={icon} color={color} className={cn(className, buttonVariants({ color }))} {...rest}>
      {children}
    </Button>
  );
});

ActionBarItem.displayName = 'ActionBarItem';
